module.exports = __webpack_public_path__ + "static/media/tiktok-gif-post-en.41380c68.gif";